import type { QueryClient } from "@tanstack/react-query";
import { RightsKeys } from "web_myplann/Api/Rights/RightsKeys";
import {
	ApiCallError,
	handleResponseError,
} from "web_myplann/Infrastructure/Api/ApiUtils";

export function handleMyPlannResponseError(
	error: unknown,
	queryClient: QueryClient,
) {
	handleResponseError(error);

	if (error instanceof ApiCallError && error.data.status === 403) {
		queryClient.invalidateQueries({ queryKey: RightsKeys.all });
	}
}
